import React, {useState, useEffect, useContext} from 'react'
import SideBar from '../Layouts/sideBar/SideBar'

import { FirebaseContext } from '../Services/firebase'

export default function Dashboard() {

    const [UserSession, setUserSession] = useState(null);
    const [Prenom, setPrenom] = useState('');
    const [Nom, setNom] = useState('');

    const firebase = useContext(FirebaseContext)

    useEffect(() => {
        firebase.auth.onAuthStateChanged(user => {
            user ? setUserSession(user) : window.location.href = '/'
        })
  
        if (UserSession !== null) {
          firebase.user(UserSession.uid).get()
          .then( doc => {
              if ( doc && doc.exists) {
                const mydata = doc.data()
                setPrenom(mydata.prenom)
                setNom(mydata.nom)
              }
          })
          .catch( error => {
            console.log(error.message)
          })
        }
        return () => {}
    })

    return (
        <>
          { UserSession !== null ? <SideBar UserSession={UserSession} Prenom={Prenom} Nom={Nom}/> : null }
        </>
    )
}

